import { defineMessages } from 'react-intl-next';

export const snippetUsageMessages = defineMessages({
	snippetUses: {
		id: 'snippets.common.usage.uses',
		defaultMessage: '{formattedCount} {count, plural, one {Use} other {Uses}}',
		description:
			'Shows the number of uses for a specific Block Template (singular "use" for 1, plural "uses" otherwise)',
	},
	privateLabel: {
		id: 'snippets.common.usage.private',
		defaultMessage: 'Private',
		description: 'Label for private block template',
	},
});
